export default __webpack_public_path__ + "static/media/welcome-face.914c4b99.png";